import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { Instagram, Twitter } from "lucide-react";
import api, { mediaUrl } from "@/lib/api";
import ArticleCard from "@/components/public/ArticleCard";

export default function AuthorPage() {
  const { id } = useParams();
  const [author, setAuthor] = useState(null);
  const [articles, setArticles] = useState([]);

  useEffect(() => {
    window.scrollTo(0, 0);
    api.get(`/authors/${id}`).then((r) => setAuthor(r.data)).catch(() => {});
    api.get(`/articles?author=${id}&limit=60`).then((r) => setArticles(r.data || [])).catch(() => {});
  }, [id]);

  if (!author) return <div className="pt-40 text-center min-h-screen text-sunset-muted">Cargando…</div>;
  const socials = author.socials || {};

  return (
    <div className="pt-32 md:pt-40 max-w-[1000px] mx-auto px-5 md:px-10 min-h-screen">
      <div className="flex flex-col items-center text-center mb-16 pb-12 border-b border-sunset-border">
        {author.photo && <img src={mediaUrl(author.photo)} alt={author.name} className="w-28 h-28 rounded-full object-cover mb-6" />}
        {author.role && <p className="kicker text-sunset-accent mb-3">{author.role}</p>}
        <h1 className="font-serif text-5xl md:text-6xl tracking-tight mb-5">{author.name}</h1>
        {author.bio && <p className="text-sunset-muted max-w-xl leading-relaxed">{author.bio}</p>}
        <div className="flex gap-4 mt-6 text-sunset-muted">
          {socials.instagram && <a href={socials.instagram} className="hover:text-sunset-accent transition-colors"><Instagram size={20} /></a>}
          {socials.twitter && <a href={socials.twitter} className="hover:text-sunset-accent transition-colors"><Twitter size={20} /></a>}
        </div>
      </div>

      <div className="grid grid-cols-1 sm:grid-cols-2 gap-10 md:gap-12">
        {articles.map((a, i) => <ArticleCard key={a.id} article={a} size="md" index={i} />)}
      </div>
    </div>
  );
}
